import React,{ useState } from 'react';
import { DateRangePickerWrapper } from 'components/Date/DateRangePicker';
import styles from './index.module.scss';
import moment from 'moment';
import ActionButton from 'components/ActionButton';
import SearchBar from 'components/Autosuggest/Autosuggest';
import { searchUserByName } from 'services';

const Filters = props =>{
  const [startDate, setStartDate] = useState<string>(moment().subtract(7, 'days').toISOString());
  const [endDate, setEndDate] = useState<string>(moment().toISOString());
  const [user, setUser] = useState<Record<string, any>>({});
  const [filters, setFilters] = useState<Record<string, string>>({ user: '' });
  const { onSubmit } = props;

  const handleLocalFilter = (key, val) => {
    const localFilters = { ...filters };
    localFilters[key] = val;
    setFilters(localFilters);
  };

  const onDateSelectionChange = ({ startDate, endDate }: { startDate: Date; endDate: Date }) => {
    setStartDate(moment(startDate).toISOString());
    setEndDate(moment(endDate).toISOString());
  };

  const handleUserSelect = (suggestion: Record<string, any>) => {
    const user: Record<string, any> = {};
    user.id = suggestion.objectId;
    user.name = suggestion.full_name;
    setFilters({ ...filters,user:user.id });
    setUser(user);
  };
    
  return(
    <div className="d-flex justify-content-between">
      <div className={styles['filter-container']}>
        <div>
          <div className={styles['label']}>Date Range</div>
          <DateRangePickerWrapper
            disabled={false}
            startDate={startDate}
            endDate={endDate}
            onDatesChange={onDateSelectionChange}
          />
        </div>
        <div className={`col-md-6 mb-4 col-lg-3`}>
          <div className={styles['label']}>User</div>
          <div className={styles['autosuggest-input']}>
            <SearchBar
              isUser={true}
              className={'form-control'}
              value={user.name || ''}
              setValue={value => setUser({ ...user, name: value })}
              searchAPI={searchUserByName}
              searchAPIParamKey={'searchTerm'}
              onSuggestionClicked={handleUserSelect}
            />
          </div>
        </div>
        <div>
          <div className={styles['label']}>User</div>
          <input
            type={'text'}
            value={filters.user}
            placeholder={'Enter User Id'}
            onChange={(e) => handleLocalFilter('user', e.target.value)}
            style={{ paddingLeft: '10px' }}
          />
        </div>
      </div>
      <div className="align-self-center mr-3">
        <ActionButton
          text={'Submit'}
          active={true}
          isLoading={false}
          onClick={()=>onSubmit({ startDate, endDate, ...filters })}
        />
      </div>
    </div>
  );
};
export default Filters;